const $ = window.jQuery;

const RenoveringsForm = {
    init() {

        const $form = $('#gform_wrapper_11');

        if (!$form.length) {
            return;
        }
        function formatState(opt) {
            var svg =
                '<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke - linejoin="round" stroke - width="2" d = "M19 9l-7 7-7-7" /></svg >';

            var optimage = $(opt.element).attr('data-image');
            if (!optimage) {
                return '<span class="single"><span class="selected-text">' + opt.text + '</span>' + svg + '</span>';
            } else {
                var $opt = $(
                    '<span><img width="36" height="36"   loading="lazy" class="select-image" src="' +
                    optimage +
                    '" height="100%" alt="' +
                    opt.text +
                    '" /><span class="selected-text">' +
                    opt.text +
                    '</span>' +
                    svg +
                    '</span>'
                );
                return $opt;
            }
        }

        function formatStateResult(opt) {
            var optimage = $(opt.element).attr('data-image');

            if (!optimage) {
                return '<span class="single"><span class="selected-text">' + opt.text + '</span></span>';
            } else {
                var $opt = $(
                    '<span><img width="36" height="36"  loading="lazy" class="select-image-results" src="' +
                    optimage +
                    '" height="100%"  alt="' +
                    opt.text +
                    '"/><span class="selected-text">' +
                    opt.text +
                    '</span></span>'
                );
                return $opt;
            }
        };

        const churchyardField = $form.find('#input_11_7');

        churchyardField.select2({
            dropdownPosition: 'below',
            width: '100%',
            allowClear: false,
            theme: 'edurus',
            dropdownCssClass: 'l-dropdown',
            placeholder: 'Välj kyrkogård',
            templateResult: formatStateResult,
            templateSelection: formatState,
            escapeMarkup: function (m) {
                return m;
            },
             /* Sort data using localeCompare */
             sorter: function(data) {
                return data.sort(function (a, b) {
                    if (a.text > b.text) {
                        return 1;
                    }
                    if (a.text < b.text) {
                        return -1;
                    }
                    return 0;
                });
            }
        });


   
        churchyardField.val("")
        churchyardField.trigger("change");


        churchyardField.on('change', function () {
        
        });

    },


};

export default RenoveringsForm;